import { DEFAULT_LANGUAGE, type Language } from '../models/settings';

function getUserCachedSettings() {
  try {
    const cached = localStorage.getItem('settings');
    if (cached) {
      const settings = JSON.parse(cached);
      return settings.language as Language;
    } else {
      return null;
    }
  } catch {
    // do nothing
    return null;
  }
}

export function getBrowserLocale(): Language {
  const userSettings = getUserCachedSettings();
  if (userSettings) {
    console.log('[locale] Using cached user settings for language:', userSettings);
    return userSettings;
  }

  // Fallback to browser language
  const userLang =
    'userLanguage' in navigator ? (navigator as { userLanguage: string }).userLanguage : navigator.language;
  const language = (userLang || '').split('-')[0] || 'ja';

  console.log('[locale] Detected browser language:', language);

  if (!['en', 'ja', 'vi', 'id'].includes(language)) {
    console.warn(`[locale] Unsupported browser language "${language}", falling back to "${DEFAULT_LANGUAGE}"`);
    return DEFAULT_LANGUAGE;
  }
  return language as Language;
}

export function saveToLocalStorage(key: string, value: string) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(key, value);
  }
}
export function getFromLocalStorage(key: string) {
  if (typeof window !== 'undefined') {
    return window.localStorage.getItem(key);
  }
  return null;
}
export function removeFromLocalStorage(key: string) {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(key);
  }
}
export function clearLocalStorage() {
  if (typeof window !== 'undefined') {
    window.localStorage.clear();
  }
}

export function saveRefCode({ refCode, userId, type }: { refCode: string; userId: string; type: 'ref' | 'coupon' }) {
  saveToLocalStorage('refCode', refCode);
  saveToLocalStorage('refUser', userId);
  saveToLocalStorage('refType', type);
}

export function getRefCode() {
  const refCode = getFromLocalStorage('refCode');
  const refUser = getFromLocalStorage('refUser');
  const refType = getFromLocalStorage('refType');
  return { refCode, refUser, refType };
}

export function removeRefCode() {
  removeFromLocalStorage('refCode');
  removeFromLocalStorage('refUser');
  removeFromLocalStorage('refType');
}
